<template>
	<div class="tombstone-dialog">
		<!--
		-- Use UID and popover visibility state to force re-renders when
		-- the dialog or popover is closed. This forces a reset of element
		-- and scroll state in slot components.
		-->
		<SparseDialog
			:key="`${ $.uid }-dialog-${ popoverVisibility }`"
			:class="dialogClasses"
			:show-dialog="popoverVisibility === `VISIBLE`"
			@hide="$emit( `close` )"
		>
			<slot :options="dialogOptions"></slot>
		</SparseDialog>
		<TombstonePopover
			:key="`${ $.uid }-popover-${ popoverVisibility }`"
			:class="tombstoneClasses"
			:popover-visibility="popoverVisibility"
			:height-ratio="heightRatio"
			@close="$emit( `close` )"
		>
			<slot :options="tombstoneOptions"></slot>
		</TombstonePopover>
	</div>
</template>

<script>

import {
	PopoverVisibility
} from "@teaming/common-enums";

import SparseDialog from "./SparseDialog.vue";

import {
	default as TombstonePopover,
	HeightRatio
} from "./TombstonePopover.vue";

export default {
	name: "TombstoneDialog",
	emits: [ "close", ],
	components: {
		SparseDialog,
		TombstonePopover,
	},
	props: {
		dialogClass: {
			type: String,
			default: "",
		},
		dialogOptions: {
			type: Object,
			default: () => {},
		},
		heightRatio: {
			type: String,
			default: HeightRatio.DEFAULT,
			validator: value => HeightRatio.includes( value ),
		},
		popoverVisibility: {
			type: String,
			default: PopoverVisibility.INDETERMINATE,
			validator: prop => PopoverVisibility.includes( prop ),
		},
		tombstoneClass: {
			type: String,
			default: "",
		},
		tombstoneOptions: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		dialogClasses() {
			const { dialogClass, } = this;
			return {
				"tombstone-dialog__sparse-dialog": true,
				[ dialogClass ]: !!dialogClass,
			};
		},
		tombstoneClasses() {
			const { tombstoneClass, } = this;
			return {
				"tombstone-dialog__tombstone-popover": true,
				[ tombstoneClass ]: !!tombstoneClass,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.tombstone-dialog .tombstone-popover {
	@include for-size-and-larger('md') {
		display: none;
	}
}
</style>
